import { Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import { NavLink } from "react-router";

export interface NavigationListProps {
    items: ReadonlyArray<ItemProps>;
}

export const NavigationList = (props: NavigationListProps) => {
    const items = props.items;
    return (
        <Stack spacing={1} padding={1}>
            {items.map((x) =>
                <Item key={x.path} path={x.path} text={x.text} />
            )}
        </Stack>
    );
};

interface ItemProps {
    readonly text: string;
    readonly path: string;
}

const Item = ({ text, path }: ItemProps) => {
    return (
        <NavLink
            to={path}
            style={{ textDecoration: 'none' }}
        >
            {({ isPending }) => (
                <Card sx={{
                    opacity: isPending ? 0.6 : 1,
                    transition: 'opacity 0.2s ease-in-out'
                }}>
                    <CardActionArea>
                        <CardContent>
                            <Typography variant="body1">
                                {text}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            )}
        </NavLink>
    );
}